<div *ngIf="!loading" [ngClass]="{ container: !urlToken }">
  <!-- NOT AUTHORIZED -->
  <div class="row" *ngIf="!authorized && !urlToken">
    <div class="col-12">
      <pv-email-auth [order]="order" (success)="authorized = true"></pv-email-auth>
    </div>
  </div>



  <!-- AUTHORIZED -->
  <div *ngIf="order && (authorized || urlToken)">

    <!-- ORDER DATE AND NUMBER -->
    <div class="row">
      <div class="col-12 order-header">
        <div>Order Date: <span class="bold">{{ order.created_at | date }} {{ order.created_at | date:'shortTime' }}</span></div>
        <!-- <div>Order Number: <span class="bold">{{ order.id }}</span></div> -->
      </div>
    </div>

    <!-- CONTACT/ISSUES -->
    <div class="row">
      <div class="col-12 questions-header">
        <div>Questions about your order? Please e-mail <a href="mailto:{{account.d2c_email}}">{{account.d2c_email}}</a> and reference order #{{order.id}}</div>
        <!-- <div>217-403-1752 ext. 223</div> -->
      </div>
    </div>


    <!-- DOWNLOAD/ACCOUNT BUTTONS -->
    <div class="row row-buttons" >
      <div [routerLink]="['/profile', 'order', order.url_token, 'download']" class="col-sm-4 offset-sm-1" *ngIf="!isWholesale">
        <div class="pv-button">Get Downloads</div>
      </div>

      <div (click)="editOrder()" class="col-sm-4 offset-sm-1" *ngIf="isWholesale && order.editable">
        <div class="pv-button warn">Add to this shipment</div>
      </div>

      <div [routerLink]="['/profile']" class="col-sm-4 offset-sm-2" *ngIf="(isWholesale && order.editable) || !isWholesale">
        <div class="pv-button">My Account</div>
      </div>
    </div>

    <!-- RECEIPT -->
    <div class="row">
      <div class="col-12 receipt-table">
        <h5 class="shipping-header">Order Receipt</h5>
        <pv-order-receipt [order]="order"
        ></pv-order-receipt>
      </div>
    </div>

    <div class="row" *ngIf="order.is_physical">
      <div class="col-12 shipping-info">
        <h5 class="shipping-header">Shipping Info</h5>
        <table class="table">
          <tr>
            <td>Shipping Method</td>
            <td>
              <div class="bold" *ngIf="order.shippingMethod && order.shippingMethod.name">{{order.shippingMethod.name}} <span *ngIf="order.shippingMethod.deliveryTime">({{order.shippingMethod.deliveryTime}})</span></div>
              <div *ngFor="let tracking of order.shippingMethod.trackings" class="tracking-set">
                <div>Shipped on {{tracking.shipDate | date}}</div>
                <div>Tracking: <a [href]="tracking.trackingUrl">{{tracking.trackingNumber}}</a></div>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="row">
                <div class="col-12">
                  Shipping Address
                </div>
              </div>
            </td>
            <td>
              <div class="bold">{{ order.shippingAddress.firstname }} {{ order.shippingAddress.lastname }}</div>
              <div>{{ order.shippingAddress.addr1 }}</div>
              <div *ngIf="order.shippingAddress.addr2">{{ order.shippingAddress.addr2 }}</div>
              <div>{{ order.shippingAddress.city }}, {{ order.shippingAddress.state }} {{ order.shippingAddress.zip }}</div>
              <div>{{ order.shippingAddress.country_iso }}</div>
              <div *ngIf="order.shippingAddress.phone">Phone: {{ order.shippingAddress.phone }}</div>
            </td>
          </tr>
        </table>
      </div>

      <!-- CHANGE ADDRESS BUTTON -->
      <div class="col-sm-3" *ngIf="!order.completed && !order.printed_datetime">
        <div class="pv-button warn" (click)="changingAddress = !changingAddress">{{changingAddress ? 'Cancel' : 'Change Address'}}</div>
      </div>

      <!-- ADDRESS FORM -->
      <div class="col-12">
        <pv-customer-address-form
          *ngIf="changingAddress"
          [selectable]="true"
          (onChange)="onAddressChange($event)"
        ></pv-customer-address-form>
      </div>

      <!-- UPDATE BUTTON -->
      <div class="col-sm-3 offset-sm-1" *ngIf="changingAddress">
        <div class="pv-button" (click)="saveAddress()" [ngClass]="{ disabled: !address }">Update</div>
      </div>

    </div>
  </div>
</div>